package hk.com.vr360_demo2.webapp.core.mvi

import cc.easyandroid.easycompose.mvi.store.StoreFactory
import cc.easyandroid.extensions_compose.mvi.StoreViewModel
import hk.com.vr360_demo2.webapp.core.either.Either
import hk.com.vr360_demo2.webapp.core.ui_state.UIComponent
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.cancel
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.filter
import kotlinx.coroutines.flow.filterIsInstance
import kotlinx.coroutines.flow.map

sealed class CommonEffect {
    data class ShowUIComponent(val uiComponent: UIComponent) : CommonEffect()
}

internal typealias EffectEither<E> = Either<E, CommonEffect>

/**
 * Effect 主要處理一次性事件，比如導航、Toast、對話框等。
 * 其中 Toast、對話框這種比較通用的事件可以使用 UIComponent 來封裝。
 */
abstract class EasyStoreViewModel<Intent : Any, Action : Any, State : Any, Message : Any, Effect : Any>(
    storeFactory: StoreFactory,
) : StoreViewModel<Intent, Action, State, Message, EffectEither<Effect>>(null, storeFactory) {

    // 處理通用 UI 錯誤提示，比如網絡異常。
    val errors: Flow<UIComponent>
        get() = sideEffect
            .filter { it.isRight() }
            .map { it.getOrNull() }
            .filterIsInstance<CommonEffect.ShowUIComponent>()
            .map { it.uiComponent }

    private val job = SupervisorJob()
    val coroutineScope: CoroutineScope = CoroutineScope(job + Dispatchers.Main)

    override fun onDestroy() {
        super.onDestroy()
        coroutineScope.cancel()
    }
}
